import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageMeta from '../components/PageMeta';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Container maxWidth="sm">
      <PageMeta title="Page not found | Anime Opening Quiz" description="Page not found." path="/404" index={false} />
      <Box component="main" sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h3" component="h1">Page not found</Typography>
        <Button variant="contained" onClick={() => navigate('/')}>Go home</Button>
      </Box>
    </Container>
  );
}
